<template>
  <div class="job-container">
    <div v-if="job">
      <span v-if="job.status !== 'done'">{{ waitingMessage }}</span>

      <em-job-status v-model="job" />

      <span v-if="job.status === 'done'">{{ successMessage }}</span>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  .job-container
    background rgba(255, 255, 255, .7)
    height 100vh
    width 100vw
    position absolute
    top 0
    left 0
    display flex
    justify-content center

    > div
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin-top - 10%

    span
      margin-top calc(var(--gap) * 2)
      margin-bottom calc(var(--gap) * 2)
      font-size 1.2rem
</style>

<script>
  import EmJobStatus from './EmJobStatus'
  import { api } from '../plugins/axios'

  export default {
    name: 'EmJobOverlay',

    components: { EmJobStatus },

    props: {
      jobId: {
        type: [String, Number],
        required: true
      },
      waitingMessage: {
        type: String,
        required: true
      },
      successMessage: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        job: null
      }
    },

    watch: {
      job (job) {
        if (job.status === 'error') {
          for (const result of job.result) {
            if (result && !result.success && result.showAsToast) {
              this.$emit('failure', new Error(result.message))
              break
            }
          }
        }
      }
    },

    created () {
      this.$loading(true)
    },

    mounted () {
      api.get(`/api/v1/jobs/${this.jobId}`).then(({ data }) => {
        this.job = data
        this.$loading(false)
      })
    }
  }
</script>
